export const kottosHost =
  process.env.API_ENV === "local" || process.env.REACT_APP_API_MOCK
    ? "http://localhost:3001"
    : process.env.REACT_APP_KOTTOS_URL;
